import { SkhemataSubscription } from './src/SkhemataSubscription.js';
import { SkhemataSubscriptionPlan } from './src/SkhemataSubscriptionPlan.js';
window.customElements.define('skhemata-subscription', SkhemataSubscription);
window.customElements.define('skhemata-subscription-plan', SkhemataSubscriptionPlan);
//# sourceMappingURL=skhemata-subscription.js.map